import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToAnchor = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.replace("#", "");
    const el = document.getElementById(id);

    if (el) {
      // небольшой таймаут нужен, чтобы React успел отрисовать страницу
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  }, [hash]);

  return null;
};
